define([
    "jquery",
    "underscore",
    "marionette",
    "forms/wallet/deposit_application_form",
    "behaviors/form_errors_behavior",
    "behaviors/modal_error_behavior",
    "backbone.syphon",
], function ($, _, Marionette, DepositApplicationModel, FormErrorsBehavior, ModalErrorBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            modalError: {
                behaviorClass: ModalErrorBehavior
            },
        },

        ui: {
            'form': '#form',
            'form_submit': '#form_submit',
            'confirm_submit': '#confirm_transfer',
            'amount': '#amount',
            'period': '#period',
            'agree': '#agree',
            'interest_rate': '#interest_rate',
            'deposit_interest': '#deposit_interest',
            'deposit_interest_completed': '#deposit_interest_completed',
            'wallet_amount': '#wallet_amount',
            'modal_amount': '#modal_amount',
            'modal_period': '#modal_period',
            'modal_interest_rate': '#modal_interest_rate',
            'hold_on_overlay': '#holdon-overlay',
        },

        events: {
            'click @ui.form_submit': 'check_form',
            'click @ui.confirm_submit': 'initiate_transfer',
            'change @ui.period': 'change_interest_rate',
            'keyup @ui.amount': function (e) {
                // Prevent anything other than 1-9 and . to be written in the amount input.
                $(e.currentTarget).val($(e.currentTarget).val().replace(/[^0-9\.]+/g, ''));
            },
        },

        initiate_transfer: function () {
            $(this.ui.deposit_interest).modal('hide');
            $(this.ui.hold_on_overlay).show();

            let that = this;
            $.ajax('/rest_saving_account/deposit_application', {
                method: "POST",
                data: {
                    "amount": $(this.ui.amount).val(),
                    "period": $(this.ui.period).val(),
                    "agree": $(this.ui.agree).val()
                },
                success: function (data) {
                    $(that.ui.wallet_amount).html(data['wallet_amount']);
                    // reset the form
                    $(that.ui.amount).val('');
                    $(that.ui.period).val('');
                    $(that.ui.agree).prop( "checked", false );

                    // show the modal
                    $(that.ui.hold_on_overlay).hide();
                    $(that.ui.deposit_interest_completed).modal('show');
                },
                error: function (xhr, textStatus, errorThrown) {
                    if (errorThrown === '') return;
                    $(that.ui.hold_on_overlay).hide();
                    that.triggerMethod('fillErrorModalContent', xhr.responseJSON);
                    that.triggerMethod('openErrorModal');
                }
            });
        },

        check_form: function (e) {
            e.preventDefault();

            this.triggerMethod('hide:errors');

            this.model = new DepositApplicationModel();
            let formData = Backbone.Syphon.serialize(this);
            this.model.set(formData);

            let errors = this.model.isValid(true, true);

            if (errors) {
                this.triggerMethod('show:errors', errors);
            } else {
                this.fill_modal();
                $(this.ui.deposit_interest).modal('show');
            }
        },

        fill_modal: function() {
            let amount = $(this.ui.amount).val();
            $(this.ui.modal_amount).html(amount);

            let period_val = $(this.ui.period).val();
            let period = $('#' + period_val).prev('td').html();
            $(this.ui.modal_period).html(period);

            let interest_rate = $(this.ui.interest_rate).html();
            $(this.ui.modal_interest_rate).html(interest_rate);
        },

        change_interest_rate: function (e) {
            if (e.target.value === '') {
                $(this.ui.interest_rate).html('')
            } else {
                let interest_rate = $("#" + e.target.value).html();
                $(this.ui.interest_rate).html(interest_rate);
            }
        }
    });
});